export default "__VITE_ASSET__8LfCKKMm__"